'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultLocale = undefined;
exports.setLocale = setLocale;
exports.getLocale = getLocale;
exports.messageFormatter = messageFormatter;

var _intlMessageformat = require('intl-messageformat');

var _intlMessageformat2 = _interopRequireDefault(_intlMessageformat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultLocale = exports.defaultLocale = typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';

var currentLocale = defaultLocale;
function setLocale(locale) {
  currentLocale = locale;
}

function getLocale() {
  return currentLocale;
}

function messageFormatter(strings) {
  var cache = {};

  return function formatMessage(key, variables, formats) {
    var message = cache[key + '.' + currentLocale];
    if (!message) {
      var localeStrings = strings[currentLocale] || strings['en-US'];
      var msg = localeStrings[key];
      if (!msg) {
        throw new Error('Could not find intl message ' + key + ' in ' + currentLocale + ' locale');
      }

      message = new _intlMessageformat2.default(msg, currentLocale, formats);
      cache[key] = message;
    }

    return message.format(variables);
  };
}